<template>
  <base-filter-select
      class="status-select-box"
      v-model="model"
      :options="computedStatusOptions"
      label="label"
      :reduce="status => status.value"
      :multiple="multiple"
      :clearable="true"
      :select-props="selectProps"
      :placeholder="placeholder"
  />
</template>

<script>
import BaseFilterSelect from '@/components/widget/select/BaseFilterSelect.vue';

export default {
  name: 'StatusSelectBox',
  components: { BaseFilterSelect },
  props: {
    value: { required: true },
    nullable: { type: Boolean, default: true },
    multiple: { type: Boolean, default: true },
    selectProps: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: () => false },
    readonly: { type: Boolean, default: () => false },
    placeholder: { type: String, default: () => '' }
  },
  computed: {
    model: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    },
    computedStatusOptions() {
      const statuses = this.$store.getters['clients/allStatuses'] || [];

      let options = statuses.map(s => ({
        label: s.status,
        value: s.id,
      }));

      if (this.nullable) {
        options = [{ label: 'NOT ASSIGNED', value: null }, ...options];
      }

      return options;
    }
  }
};
</script>
